export default __webpack_public_path__ + "static/media/upload-cloud.fa536a65.svg";